import { z } from "zod";
import { QcUnreadMessageSchema } from "./QcUnreadMessage";

export type ModelQcUnreadMessageList = z.infer<typeof ModelQcUnreadMessageListSchema>;
export const ModelQcUnreadMessageListSchema = z.object({
  items: z.array(QcUnreadMessageSchema),
  nextPage: z.number(),
});
